<nb-card class="autorizar-titular-dialog">

  <nb-card-header>
    Autorizar Titular
  </nb-card-header>

  <nb-card-body>

    <ng-container *ngIf="esCompany; else autorizacionEmpresa">

      <p>
        Si su empresa trabaja con una entidad habilitada diferente de
        AIDIAPP recuerde que esta debe gestionar las autorizaciones de los
        titulares para que VisorCUE acceda a sus datos.
      </p>

      <p>
        Si esta autorización ya se ha registrado en su Comunidad Autónoma
        puede activar la autorización pulsando el botón
        <strong>AUTORIZACIÓN REALIZADA</strong>.
      </p>

      <p>
        Si su empresa trabaja con AIDIAPP como entidad habilitada descargue
        el modelo de autorización (pulse el botón
        <strong>DESCARGAR MODELO</strong>), imprímalo. El titular deberá
        firmarlo y luego podrá escanearlo como archivo PDF y enviárnoslo
        pulsando el botón
        <strong>ENVIAR AUTORIZACION</strong>.
      </p>

    </ng-container>

    <ng-template #autorizacionEmpresa>

      <p>
        Recuerde que como entidad habilitada, debe registrar las autorizaciones 
        según lo indicado en su comunidad autónoma. Puede descargar el documento 
        de autorización para que lo firme el titular o si ya ha registrado la 
        autorización marcar al titular como autorizado.
      </p>

    </ng-template>


    <div class="acciones">

      <button
        nbButton
        status="success"
        [disabled]="loading"
        (click)="confirmarAutorizacion()">

        AUTORIZACIÓN REALIZADA

      </button>

      <button
        nbButton
        status="info"
        [disabled]="loading"
        (click)="descargarModelo()">

        DESCARGAR MODELO

      </button>

    </div>


   <ng-container *ngIf="esCompany">

    <hr>

    <div class="subir-pdf">

      <label>
        Seleccione el PDF de autorización:
      </label>

      <input
        type="file"
        accept="application/pdf"
        (change)="seleccionarArchivo($event)"
        [disabled]="loading"
      >

      <div
        *ngIf="fileName"
        class="nombre-archivo">

        Archivo seleccionado:
        <strong>
          {{ fileName }}
        </strong>

      </div>

    </div>

    <div class="acciones">

      <button
        nbButton
        status="primary"
        [disabled]="loading || !fileBase64"
        (click)="enviarAutorizacion()">

        ENVIAR AUTORIZACION

      </button>

    </div>

   </ng-container>

  </nb-card-body>

  <nb-card-footer>

    <button
      nbButton
      status="basic"
      [disabled]="loading"
      (click)="cerrar()">

      CERRAR

    </button>

  </nb-card-footer>

</nb-card>